<template>
  <v-container class="login my-5">
    <v-layout row justify-space-around>
      <v-flex xs12 sm7 md5 lg4 xl3 class="text-xs-center">
        <v-card outlined class="pa-3 mt-5">
          <v-card-text>
            <v-form class="text-xs-center">
              <h2 class="py-3 mb-3 display-1 text-center orange--text">Omentum</h2>
              <v-text-field :height="20" class="px-3" single-line outlined type="text" label="Email" v-model="email"></v-text-field>
              <v-text-field v-if="!resetPassword" class="px-3" single-line outlined type="password" label="Password" v-model="password"></v-text-field>
              <a class="ma-2" v-if="!resetPassword" @click="resetPassword = true">Forgot your password?</a>
              <a class="ma-2" v-if="resetPassword" @click="resetPassword = false">Need to login?</a>

            </v-form>
          </v-card-text>
          <v-card-actions class="text-xs-center">
            <v-spacer></v-spacer>


            <v-btn dark rounded depressed large v-if="!resetPassword" @click="login" :loading="loading" color="orange">Login</v-btn>
            <v-btn dark rounded depressed large v-if="resetPassword" @click="resetPasswordFunction" :loading="loading" color="orange">Reset Passsword</v-btn>

            <v-spacer></v-spacer>


          </v-card-actions>
          <v-alert v-if="feedback" dense dark outlined color="red">{{feedback}}</v-alert>
          <v-alert v-if="emailSent" dense dark outlined color="green">Email Sent! Reset your password then <a @click="resetFields">click to login</a></v-alert>


        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Login',
  data() {
    return {
      email: null,
      password: null,
      loading: false,
      feedback: null,
      resetPassword: false,
      emailSent: false,
      tag: null,
    }
  },
  mounted() {
    if (this.$route.params.tag) {
      this.tag = this.$route.params.tag
    }
  },
  methods: {

    login() {
        if (this.email && this.password) {
          this.loading = true
          this.feedback = null

          firebase.auth().signInWithEmailAndPassword(this.email, this.password)
          .then(cred => {
            this.$router.push({ name: 'Home', params: {tag: this.tag} })
            this.loading = false
          }).catch(err => {
            this.feedback = err.message
            this.loading = false
          })

        } else {
          this.feedback = "Please fillin both fields."
        }
      },
      resetPasswordFunction() {
        if (this.email) {
          this.loading = true
          this.feedback = null

          // firebase.auth().sendPasswordResetEmail(this.email).then(response => {
          //   this.loading = false
          //   this.emailSent = true
          //   this.recordPasswordReset()
          //
          // }).catch(function(error) {
          //   console.log(error)
          // });
          let data = {email: this.email}
          let resetPasswordEmail = firebase.functions().httpsCallable('resetPasswordEmail')
          resetPasswordEmail(data).then(res => {
            this.loading = false
            this.emailSent = true
            this.recordPasswordReset()

          }).catch(function(error) {
            console.log(error)
          });




        }
        else {
          this.feedback = "Provide email address"
        }
      },
      resetFields() {
        this.password = null
        this.loading = false,
        this.feedback = null,
        this.resetPassword = false
        this.emailSent = false
      },
      recordPasswordReset(){
        let data = {
          email: this.email
        }
        let logPasswordRest = firebase.functions().httpsCallable('logPasswordRest')
        logPasswordRest(data)
        .then(response => {
          console.log(response)
        })
      },

  },

}
</script>

<style>

</style>
